import { uuidV4 } from '../../util/others/uuid-v4.js';

/** set new uuid for object and all its children */
function deepNewUuid(obj) {
    obj.uuid = uuidV4();
    for (const c of obj.children) {
        deepNewUuid(c);
    }
    return obj;
}

export { deepNewUuid };
//# sourceMappingURL=deep-new-uuid.js.map
